module.exports = __webpack_public_path__ + "static/media/0209_Small.0dd25249.jpg";